<div class="inferences-container">

  <!-- Header -->
  <div class="inferences-header">
    <div class="inferences-header-left">
      <button class="back-button" (click)="onBackClick()" aria-label="Back to chat">
        <img src="assets/icons/collection-arrow.svg" alt="Back" class="back-arrow-icon">
      </button>
      <h1 class="inferences-title">Inferences</h1>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
  </div>

  <!-- Error -->
  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-content">
      <i class="fas fa-exclamation-triangle error-icon"></i>
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="syncInferences()">
        Sync Now
      </button>
    </div>
  </div>

  <!-- Empty state: nothing generated yet -->
  <div class="error-state" *ngIf="!isLoading && !error && inferences.length === 0">
    <div class="error-content">
      <p class="error-message">No inferences yet. Open Clusters in the sidebar, run Clusterize, then generate inferences from a document or cluster.</p>
    </div>
  </div>

  <!-- Main Content -->
  <div class="inferences-body" *ngIf="!isLoading && !error && inferences.length > 0">

    <!-- LEFT PANEL -->
    <div class="inferences-content" [class.detail-open]="selectedInference">

      <div class="inferences-scrollable">

        <div class="inferences-tabs" role="tablist" aria-label="Inference recency">
          <button
            type="button"
            class="inferences-tab"
            role="tab"
            [class.active]="activeTab === 'recent'"
            [attr.aria-selected]="activeTab === 'recent'"
            (click)="selectTab('recent')">
            Recent
            <span class="tab-count">{{ recentCount }}</span>
          </button>
          <button
            type="button"
            class="inferences-tab"
            role="tab"
            [class.active]="activeTab === 'history'"
            [attr.aria-selected]="activeTab === 'history'"
            (click)="selectTab('history')">
            History
            <span class="tab-count">{{ historyCount }}</span>
          </button>
        </div>

        <!-- Statistics -->
        <div class="stats-container">

          <div class="stat-card stat-critical">
            <div class="stat-icon">
              <img [src]="getSeverityIcon('critical')" alt="Critical" />
            </div>
            <div class="stat-content">
              <div class="stat-number">{{ getCountBySeverity('critical') }}</div>
              <div class="stat-label">Critical</div>
            </div>
          </div>

          <div class="stat-card stat-high">
            <div class="stat-icon">
              <img [src]="getSeverityIcon('high')" alt="High" />
            </div>
            <div class="stat-content">
              <div class="stat-number">{{ getCountBySeverity('high') }}</div>
              <div class="stat-label">High</div>
            </div>
          </div>

          <div class="stat-card stat-medium">
            <div class="stat-icon">
              <img [src]="getSeverityIcon('medium')" alt="Medium" />
            </div>
            <div class="stat-content">
              <div class="stat-number">{{ getCountBySeverity('medium') }}</div>
              <div class="stat-label">Medium</div>
            </div>
          </div>

          <div class="stat-card stat-low">
            <div class="stat-icon">
              <img [src]="getSeverityIcon('low')" alt="Low" />
            </div>
            <div class="stat-content">
              <div class="stat-number">{{ getCountBySeverity('low') }}</div>
              <div class="stat-label">Low</div>
            </div>
          </div>

        </div>

        <!-- Filters -->
        <div class="filters-container">

          <div class="filter-group">
            <label>Cluster</label>
            <select class="filter-select"
                    [(ngModel)]="selectedCluster"
                    (change)="onFilterChange()">
              <option *ngFor="let option of clusterOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label>Severity</label>
            <select class="filter-select"
                    [(ngModel)]="selectedSeverity"
                    (change)="onFilterChange()">
              <option *ngFor="let option of severityOptions" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label>Inference Type</label>
            <select class="filter-select"
                    [(ngModel)]="selectedType"
                    (change)="onFilterChange()">
              <option *ngFor="let option of typeOptions" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label>Confidence</label>
            <select class="filter-select"
                    [(ngModel)]="selectedConfidence"
                    (change)="onFilterChange()">
              <option *ngFor="let option of confidenceOptions" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>

          <div class="filter-group filter-group-search">
            <label>Search</label>
            <input
              type="text"
              class="filter-input"
              [(ngModel)]="searchQuery"
              (input)="onFilterChange()"
              placeholder="Search title or description" />
          </div>
        </div>

        <!-- Results -->
        <div class="results-header" *ngIf="tabInferences.length > 0">
          <div class="results-count">
            {{ filteredInferences.length }}
            inference{{ filteredInferences.length !== 1 ? 's' : '' }} found
          </div>
        </div>

        <!-- Cards -->
        <div class="inferences-list" *ngIf="tabInferences.length > 0">

          <div
            class="inference-card"
            [ngClass]="'severity-' + inference.severity.toLowerCase()"
            *ngFor="let inference of filteredInferences"
            (click)="selectInference(inference)"
            [class.selected]="isSelected(inference)">

            <div class="inference-card-main">
              <div class="inference-icon" [ngClass]="'severity-' + inference.severity.toLowerCase()">
                <img [src]="getSeverityIcon(inference.severity)" [alt]="inference.severity" />
              </div>

              <div class="inference-main-content">
                <div class="inference-title-row">
                  <div
                    class="severity-badge"
                    [ngClass]="'severity-' + inference.severity.toLowerCase()">
                    {{ inference.severity }}
                  </div>
                  <h3 class="inference-title" [innerHTML]="highlightSearchTerm(inference.topic)">
                  </h3>
                </div>

                <p class="inference-description" [innerHTML]="highlightSearchTerm(inference.inference)">
                </p>

                <div class="inference-tags">
                  <span class="tag" *ngFor="let fact of inference.supporting_facts | slice:0:3">
                    {{ fact.source }}
                  </span>
                  <span *ngIf="inference.supporting_facts.length > 3" class="tag tag-more">+{{ inference.supporting_facts.length - 3 }}</span>
                </div>
              </div>

              <div class="inference-sidebar">
                <div class="confidence-badge">
                  Confidence {{ getConfidencePercentage(inference.confidence) }}%
                </div>

                <div class="inference-meta">
                  <div class="meta-item-stack">
                    <span class="meta-label">Type</span>
                    <span class="meta-value">{{ formatTypeName(inference.inference_type) }}</span>
                  </div>
                  <div class="meta-item-stack">
                    <span class="meta-label">Cluster</span>
                    <span class="meta-value" [title]="inference.cluster_run_id || clusterLabel(inference)">{{ clusterLabel(inference) }}</span>
                  </div>
                  <div class="meta-item-stack" *ngIf="inference.created_at">
                    <span class="meta-label">Time</span>
                    <span class="meta-value" [title]="formatAbsoluteTime(inference.created_at)">{{ formatRelativeTime(inference.created_at) }}</span>
                  </div>
                  <div class="meta-item-stack">
                    <span class="meta-label">Facts</span>
                    <span class="meta-value">{{ inference.supporting_facts.length }}</span>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="tab-empty-state" *ngIf="tabInferences.length === 0">
          <p class="tab-empty-message">{{ tabEmptyMessage }}</p>
        </div>

      </div>

    </div>
    <!-- END LEFT PANEL -->


    <!-- RIGHT PANEL -->
    <div class="inference-detail-panel" *ngIf="selectedInference">

      <div class="detail-panel-header">

        <h2 class="detail-panel-title">
          Inference Details
        </h2>

        <button
          class="detail-close-button"
          (click)="closeDetailPanel()">

          <svg viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>

        </button>

      </div>

      <div class="detail-panel-scrollable">

        <div class="detail-severity-row">

          <div
            class="severity-badge"
            [ngClass]="'severity-' + selectedInference.severity.toLowerCase()">

            {{ selectedInference.severity }}

          </div>

          <div class="confidence-badge">
            {{ getConfidencePercentage(selectedInference.confidence) }}%
            Confidence
          </div>

        </div>

        <div class="detail-type-badge">
          Type: {{ formatTypeName(selectedInference.inference_type) }}
        </div>

        <div class="detail-meta-row">
          <span class="detail-meta-chip" [title]="selectedInference.cluster_run_id || clusterLabel(selectedInference)">{{ clusterLabel(selectedInference) }}</span>
          <span
            class="detail-meta-chip"
            *ngIf="selectedInference.created_at"
            [title]="formatAbsoluteTime(selectedInference.created_at)">
            {{ formatRelativeTime(selectedInference.created_at) }}
          </span>
        </div>

        <h3 class="detail-topic">
          {{ selectedInference.topic }}
        </h3>

        <p class="detail-inference">
          {{ selectedInference.inference }}
        </p>

        <!-- Supporting Facts -->
        <div class="detail-section">

          <div class="detail-section-title">
            <span>Supporting Facts</span>
          </div>

          <div class="detail-facts-list">

            <div
              class="detail-fact-item"
              *ngFor="let fact of selectedInference.supporting_facts">

              <div class="fact-node fact-source">
                {{ fact.source }}
              </div>

              <div class="fact-relationship">
                {{ fact.relationship }}
              </div>

              <div class="fact-node fact-target">
                {{ fact.target }}
              </div>

            </div>

          </div>

        </div>

        <!-- Recommendation -->
        <div class="detail-section">
          <div class="detail-section-title">
            Recommended Action
          </div>

          <p class="detail-recommendation">
            {{ selectedInference.recommended_action }}
          </p>
        </div>

        <!-- Graph -->
        <div class="detail-section">

          <div class="detail-section-title">
            <span>Relationship Graph</span>
            <button
              class="detail-graph-expand-btn"
              (click)="toggleGraphFullScreen()"
              [attr.aria-label]="'Expand graph'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/>
              </svg>
            </button>
          </div>

          <div
            class="detail-graph"
            *ngIf="detailGraphElements.length">

            <app-graph
              [elements]="detailGraphElements">
            </app-graph>

          </div>

        </div>

        <!-- Source Documents -->
        <div class="detail-section" *ngIf="hasDocumentSources()">
          <div class="detail-section-title">
            <span>Source Documents ({{ selectedInference.sources?.length || 0 }})</span>
          </div>
          
          <div class="source-documents-list">
            <div class="source-document-item" *ngFor="let source of selectedInference.sources!; let i = index">
              <div class="doc-icon" [style.background-color]="getDocumentIcon(i)">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  <polyline points="14,2 14,8 20,8"/>
                </svg>
              </div>
              <span class="doc-name">{{ source }}</span>
            </div>
          </div>
        </div>

        <!-- Status -->
        <div class="detail-section">
          <div class="detail-section-title">
            <span>Status</span>
          </div>
          
          <div class="status-actions">
            <button class="status-btn status-accept" (click)="acceptInference()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 11l3 3L22 4"/>
                <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
              </svg>
              <span>Accept</span>
            </button>

            <button class="status-btn status-reject" (click)="rejectInference()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <span>Reject</span>
            </button>

            <button class="status-btn status-assign" (click)="assignInference()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              <span>Assign</span>
            </button>
          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- Graph Fullscreen Overlay -->
  <div class="graph-fullscreen-overlay" *ngIf="isGraphFullScreen && selectedInference">
    <div class="graph-fullscreen-header">
      <button class="graph-fullscreen-back" (click)="toggleGraphFullScreen()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 12H5m7-7l-7 7 7 7"/>
        </svg>
        <!-- Back -->
      </button>
      <h2 class="graph-fullscreen-title">Relationship Graph ( {{ selectedInference.topic }} )</h2>
    </div>
    <div class="graph-fullscreen-body">
      <app-graph
        [elements]="detailGraphElements">
      </app-graph>
    </div>
  </div>

</div>
